import type { Template } from "@/types";

export const PO_05_H3_V2: Template[] = [
    {
        id: "po-05-h3v2-01",
        name: "PO 01 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 34, y: 223, width: 306, height: 469, rotation: 0, imageRotation: 0 },
            { id: "2", x: 348, y: 223, width: 306, height: 469, rotation: 0, imageRotation: 0 },
            { id: "3", x: 795, y: 223, width: 478, height: 306, rotation: 0, imageRotation: 0 },
            { id: "4", x: 795, y: 536, width: 235, height: 157, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1038, y: 536, width: 235, height: 157, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-02",
        name: "PO 02 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 47, y: 170, width: 586, height: 371, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 549, width: 289, height: 197, rotation: 0, imageRotation: 0 },
            { id: "3", x: 344, y: 549, width: 289, height: 197, rotation: 0, imageRotation: 0 },
            { id: "4", x: 721, y: 223, width: 306, height: 469, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1035, y: 223, width: 306, height: 469, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-03",
        name: "PO 03 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 48, y: 155, width: 591, height: 394, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 557, width: 142, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 498, y: 557, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 198, y: 557, width: 292, height: 204, rotation: 0, imageRotation: 0 },
            { id: "5", x: 735, y: 261, width: 591, height: 394, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h3v2-04",
        name: "PO 04 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 33, y: 224, width: 306, height: 469, rotation: 0, imageRotation: 0 },
            { id: "2", x: 347, y: 224, width: 306, height: 469, rotation: 0, imageRotation: 0 },
            { id: "3", x: 741, y: 170, width: 289, height: 197, rotation: 0, imageRotation: 0 },
            { id: "4", x: 741, y: 375, width: 586, height: 371, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1038, y: 170, width: 289, height: 197, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-05",
        name: "PO 05 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 192, width: 390, height: 262, rotation: 0, imageRotation: 0 },
            { id: "2", x: 398, y: 192, width: 174, height: 262, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 462, width: 174, height: 262, rotation: 0, imageRotation: 0 },
            { id: "4", x: 182, y: 462, width: 390, height: 262, rotation: 0, imageRotation: 0 },
            { id: "5", x: 580, y: 192, width: 793, height: 532, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-06",
        name: "PO 06 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 257, width: 545, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 553, y: 257, width: 268, height: 402, rotation: 0, imageRotation: 0 },
            { id: "3", x: 829, y: 257, width: 268, height: 402, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1105, y: 257, width: 269, height: 197, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1105, y: 462, width: 269, height: 197, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h3v2-07",
        name: "PO 07 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 91, y: 145, width: 416, height: 624, rotation: 0, imageRotation: 0 },
            { id: "2", x: 515, y: 145, width: 459, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 515, y: 462, width: 459, height: 308, rotation: 0, imageRotation: 0 },
            { id: "4", x: 982, y: 145, width: 300, height: 414, rotation: 0, imageRotation: 0 },
            { id: "5", x: 982, y: 567, width: 300, height: 203, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h3v2-08",
        name: "PO 08 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 76, y: 125, width: 442, height: 665, rotation: 0, imageRotation: 0 },
            { id: "2", x: 526, y: 125, width: 323, height: 217, rotation: 0, imageRotation: 0 },
            { id: "3", x: 526, y: 350, width: 323, height: 216, rotation: 0, imageRotation: 0 },
            { id: "4", x: 526, y: 574, width: 323, height: 216, rotation: 0, imageRotation: 0 },
            { id: "5", x: 857, y: 125, width: 442, height: 665, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h3v2-09",
        name: "PO 09 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 257, width: 546, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 553, y: 257, width: 268, height: 402, rotation: 0, imageRotation: 0 },      
            { id: "3", x: 829, y: 257, width: 269, height: 197, rotation: 0, imageRotation: 0 },
            { id: "4", x: 829, y: 462, width: 269, height: 197, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1106, y: 257, width: 268, height: 402, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h3v2-10",
        name: "PO 10 - H3V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h3_v2_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 76, y: 125, width: 442, height: 665, rotation: 0, imageRotation: 0 },
            { id: "2", x: 526, y: 125, width: 442, height: 665, rotation: 0, imageRotation: 0 },
            { id: "3", x: 976, y: 125, width: 323, height: 217, rotation: 0, imageRotation: 0 },
            { id: "4", x: 976, y: 350, width: 323, height: 216, rotation: 0, imageRotation: 0 },
            { id: "5", x: 976, y: 574, width: 323, height: 216, rotation: 0, imageRotation: 0 }
        ],
    },
    

];

